import { IMessenger, Symbol } from '@map/core';
import { SpinnerModule } from './SpinnerModule';
import { ISpinnerService } from './ISpinnerService';
import { HideSpinnerMessage } from './HideSpinnerMessage';

/**
 * The standard implementation of the ISpinnerService.
 */
export class SpinnerService implements ISpinnerService {
  constructor(private messenger: IMessenger) {
  }

  /**
   * Hide the spinner in the current browser.
   */
  readonly hideSpinner = (): void => {
    this.messenger.send(new HideSpinnerMessage());
  }

  readonly symbol: Symbol = SpinnerModule.serviceSymbol;
}
